import { render, staticRenderFns } from "./BranchesReport.vue?vue&type=template&id=5b292833"
import script from "./BranchesReport.vue?vue&type=script&lang=js"
export * from "./BranchesReport.vue?vue&type=script&lang=js"
import style0 from "./BranchesReport.vue?vue&type=style&index=0&id=5b292833&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports